import { createContext, useState, useEffect } from 'react'

const AuthContext = createContext({})

export const AuthProvider = ({ children }) => {
  const [auth, setAuth] = useState({})
  const [userPolicy, setUserPolicy] = useState({})
  const [policyStaff, setPolicyStaff] = useState({})
  const [showLoader, setShowLoader] = useState(false)
  const [showInfo, setShowInfo] = useState()
  const [showUpdate, setShowUpdate] = useState(false)
  const [notNow, setNotNow] = useState(false)
  const [showReportConfirmation, setShowReportConfirmation] = useState(false)

  useEffect(() => {
    if (auth?.user?.client?.policy) {
      setUserPolicy(auth.user.client.policy)
    }
  }, [auth?.user?.client?.policy])

  useEffect(() => {
    if (auth?.user?.policyStaff) {
      setPolicyStaff(auth?.user?.policyStaff)
    }
  }, [auth?.user?.policyStaff])

  // Initialize orgDetails from localStorage
  const [orgDetails, setOrgDetailsState] = useState(() => {
    try {
      const stored = localStorage.getItem('orgDetails')
      return stored ? JSON.parse(stored) : null
    } catch {
      return null
    }
  })

  // Wrapper function to persist to localStorage
  const setOrgDetails = (details) => {
    setOrgDetailsState(details)
    if (details) {
      localStorage.setItem('orgDetails', JSON.stringify(details))
    } else {
      localStorage.removeItem('orgDetails')
    }
  }

  const createInfo = (type, message, timeout = 6000) => {
    setShowInfo({ type, message, show: 'show' })
    setTimeout(() => {
      setShowInfo({})
    }, timeout)
  }

  const adminUsers = ['Super User', 'Admin']

  // const user = auth.user;
  const can = (permission) =>
    (auth.user?.permissions || []).find(
      (p) => p.toLowerCase() === permission.toLowerCase()
    )
      ? true
      : false
  const admin = adminUsers.includes(auth?.user?.type)
  // const [persist, setPersist] = useState(JSON.parse(localStorage.getItem('persist')) || true)

  return (
    <AuthContext.Provider
      value={{
        auth,
        setAuth,
        userPolicy,
        policyStaff,
        can,
        admin,
        showLoader,
        setShowLoader,
        showInfo,
        createInfo,
        showUpdate,
        setShowUpdate,
        showReportConfirmation,
        setShowReportConfirmation,
        notNow,
        setNotNow,
        orgDetails,
        setOrgDetails,
      }}
    >
      {children}
    </AuthContext.Provider>
  )
}

export default AuthContext
